var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "52px",
    viewBox: "0 0 66 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "id-card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-1374.000000, -2501.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other-features",
    transform: "translate(0.000000, 2396.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Always-on-You",
    transform: "translate(1260.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id-card",
    transform: "translate(116.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 2.69047619,
    x: 0,
    y: 7,
    width: 56,
    height: 41
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-5",
    strokeWidth: 2.69047619,
    points: "6 0 62 0 62 41 56.1000843 41 56 6.55792696 6 6.55792696"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.62666667,
    y1: 17.2567125,
    x2: 28,
    y2: 17.2567125,
    id: "Path",
    strokeWidth: 2.69047619
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.62666667,
    y1: 27.513425,
    x2: 28,
    y2: 27.513425,
    id: "Path",
    strokeWidth: 2.69047619
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.62666667,
    y1: 37.7701375,
    x2: 22.9066667,
    y2: 37.7701375,
    id: "Path",
    strokeWidth: 2.69047619
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 2.69047619,
    x: 35.6266667,
    y: 17.2567125,
    width: 10.1866667,
    height: 10.2567125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6668546,41",
    id: "Path-4"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.3c4ccd71d9ac17d8322a4816c71c62d7.svg";
export { ForwardRef as ReactComponent };